// Partenaires et sponsors (D-033) : libellés, totaux du bureau, visibilité.
// Le sponsoring et le mécénat ne se traitent pas pareil (facture / reçu fiscal).

export type PartnerKind = 'sponsor' | 'mecene' | 'institution' | 'fournisseur';
export type Placement = 'public' | 'match' | 'banner' | 'offer' | 'event';

export const KIND_LABEL: Record<PartnerKind, string> = {
  sponsor: 'Sponsor', mecene: 'Mécène', institution: 'Institution', fournisseur: 'En nature',
};
/** Ce que ça implique pour le trésorier. */
export const KIND_HINT: Record<PartnerKind, string> = {
  sponsor: 'Sponsoring : une prestation de visibilité, le club fait une facture.',
  mecene: 'Mécénat : un don ; reçu fiscal seulement si le club est d’intérêt général, contreparties limitées.',
  institution: 'Institution : subvention (mairie, département, région…).',
  fournisseur: 'En nature : matériel, services, dotations.',
};
export const PLACEMENT_LABEL: Record<Placement, string> = {
  public: 'Page publique', match: '« Match présenté par »', banner: 'Bannière de l’app', offer: 'Offre aux membres', event: 'Événements du club',
};

export interface StatRow { partner_id: string; placement: Placement; views: number; clicks: number }

/** Vues et clics d'un partenaire (ou de tous), au total et par emplacement. */
export function sumStats(rows: StatRow[], partnerId?: string) {
  const by: Partial<Record<Placement, { views: number; clicks: number }>> = {};
  let views = 0, clicks = 0;
  for (const r of rows) {
    if (partnerId && r.partner_id !== partnerId) continue;
    views += r.views; clicks += r.clicks;
    const b = (by[r.placement] ??= { views: 0, clicks: 0 });
    b.views += r.views; b.clicks += r.clicks;
  }
  return { views, clicks, by };
}

/** Apports de la saison par nature de partenariat (en centimes). */
export function totalsByKind(partners: { kind: PartnerKind; amount_cents: number | null }[]) {
  const t: Record<PartnerKind, number> = { sponsor: 0, mecene: 0, institution: 0, fournisseur: 0 };
  for (const p of partners) t[p.kind] += p.amount_cents ?? 0;
  return t;
}

/** « 1 vue », « 12 vues » ; « 0 clic », « 3 clics ». */
export const views = (n: number) => `${n.toLocaleString('fr-FR')} ${n > 1 ? 'vues' : 'vue'}`;
export const clicks = (n: number) => `${n.toLocaleString('fr-FR')} ${n > 1 ? 'clics' : 'clic'}`;

/** Bannière du jour : chacun son tour, le même toute la journée pour tout le monde. */
export function bannerOfTheDay<T>(list: T[], isoDay: string): T | null {
  if (!list.length) return null;
  const n = Math.floor(Date.parse(`${isoDay}T00:00:00Z`) / 86_400_000);
  return list[((n % list.length) + list.length) % list.length] ?? null;
}
